import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { updateDept } from "@/api/admin/dept";
import treeMenu from "@/components/treeMenu/index.vue";
export default {
  props: {
    editData: {
      type: Object,
      required: true
    }
  },
  components: {
    treeMenu: treeMenu
  },
  data: function data() {
    return {
      subDisabled: false,
      ruleForm: {},
      orgLevel: [{
        value: "1",
        label: "校级"
      }, {
        value: "2",
        label: "院系"
      }, {
        value: "3",
        label: "专业"
      }, {
        value: "4",
        label: "班级"
      }],
      teachUnit: [{
        value: "1",
        label: "是"
      }, {
        value: "0",
        label: "否"
      }],
      formValidate: _defineProperty({
        deptId: "",
        // deptCode: '',
        // organLevel: '',
        name: "",
        // organType: '',
        sort: "",
        // joinHie: '',
        parentId: "",
        deptCode: ""
      }, "sort", ""),
      // 表单数据绑定
      ruleValidate: {
        name: [{
          required: true,
          message: "部门名称不能为空",
          trigger: "blur"
        }, {
          min: 1,
          max: 50,
          message: "长度在 1 到 50 个字符",
          trigger: "blur"
        }],
        deptCode: [{
          required: true,
          message: "部门编码不能为空",
          trigger: "blur"
        }, {
          min: 1,
          max: 50,
          message: "长度在 1 到 50 个字符",
          trigger: "blur"
        }]
      },
      // 表单验证
      chooseDepartment: {
        state: false,
        data: {},
        showBox: false
      }
    };
  },
  computed: {},
  methods: {
    changeUserDept: function changeUserDept() {
      this.chooseDepartment.data = {};
      this.chooseDepartment.chooseBox = false;
      this.chooseDepartment.state = true;
    },
    nodeIdModal: function nodeIdModal(tree) {
      console.log(tree);
      this.chooseDepartment.data = tree;
    },
    depTreeBtn: function depTreeBtn() {
      this.formValidate.parentId = this.chooseDepartment.data.id; // this.formValidate.deptName = this.chooseDepartment.data.name;

      this.chooseDepartment.state = false;
    },

    /**
     * @description: 上级部门
     * @param:{pagesize, pageindex, deptId}
     * @return:
     */
    searchParentName: function searchParentName(parentId) {
      var parentName;

      var searchParentName = function searchParentName(searchdata, searchpid) {
        searchdata.forEach(function (e) {
          if (e.id == searchpid) {
            parentName = e.name;
            return;
          } else {
            if (e.children.length > 0) {
              searchParentName(e.children, searchpid);
            }
          }
        });
      };

      console.log(this.$store.getters.chooseDept);
      searchParentName(this.$store.getters.chooseDept, parentId);
      return parentName;
    },
    showEditData: function showEditData() {
      // this.formValidate.deptCode = this.editData.data.deptCode;
      this.formValidate.name = this.editData.data.name; // this.formValidate.organLevel = this.editData.data.organLevel.toString();
      // this.formValidate.organType = this.editData.data.organType.toString();

      this.formValidate.sort = this.editData.data.sort;
      this.formValidate.parentId = this.editData.data.parentId; // this.formValidate.joinHie = parseInt(this.editData.data.joinHie);

      this.formValidate.deptId = this.editData.data.deptId;
      this.formValidate.deptCode = this.editData.data.deptCode;
      this.formValidate.sort = this.editData.data.sort;
    },
    closeModal: function closeModal() {
      this.$emit("closeEdit", {
        state: false
      });
      this.editData.state = false;
      this.resetForm("ruleForm");
    },
    submitForm: function submitForm(formName) {
      var _this = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this.subDisabled = true;
          updateDept(_this.formValidate).then(function (res) {
            _this.subDisabled = false;

            if (res.data.code == 0) {
              _this.$store.dispatch("getDeptTree").then(function (data) {
                _this.$store.commit("SET_CHOOSE_DEPT", data.data.data);
              });

              _this.closeModal();
            } else {
              _this.$alert(res.data.msg, "提示", {
                confirmButtonText: "确定",
                type: "warning"
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields(); // this.formValidate.name = ''
      // this.formValidate.deptCode = ''

      this.formValidate.deptCode = this.editData.data.deptCode;
      this.formValidate.sort = this.editData.data.sort;
      this.formValidate.name = this.editData.data.name; // this.formValidate.organLevel = this.editData.data.organLevel.toString();
      // this.formValidate.organType = this.editData.data.organType.toString();

      this.formValidate.sort = this.editData.data.sort;
      this.formValidate.parentId = this.editData.data.parentId; // this.formValidate.joinHie = parseInt(this.editData.data.joinHie);

      this.formValidate.deptId = this.editData.data.deptId;
      setTimeout(function () {}, 200);
    }
  }
};